export enum FeatureFlagsEnum {
  visible_locale_france = 'visible_locale_france',
  show_info_source = 'info_source',
}
